<script>
    // TODO: General clean-up needed to this old Svelte component

    // imports
    import { createEventDispatcher } from 'svelte';
    import {clickOutside} from '../util.js';
    import {trackPage} from '../api.js';
    import { PAGE_QUERY_STRING, ENV_URL } from '../config.js';
    import { fade } from 'svelte/transition';
    import Logo from "../shared/Logo.svelte";

    // exports
    export let pageTitle = 'Page title here!';

    // local vars
    let subMenuToggle = false;
    let testProducts = [
      {
        title: 'BiOS',
        image: 'https://web.hamiltonsupport.com/uploads/storageSolutions/Pages/BiOS/Image/header-product-bios.jpg',
        link: 'bios'
      },
      {
        title: 'Verso Q-Series',
        image: 'https://web.hamiltonsupport.com/uploads/storageSolutions/Pages/Verso-Q-Series/Image/header-product-verso-q-series.jpg',
        link: 'verso-q-series'
      },
      {
        title: 'SAM HD',
        image: 'https://web.hamiltonsupport.com/uploads/storageSolutions/Pages/SAM-HD/Image/header-product-sam-hd.jpg',
        link: 'sam-hd'
      },
      {
        title: 'LabElite',
        image: 'https://web.hamiltonsupport.com/uploads/storageSolutions/Pages/LabElite/Image/header-product-labelite.jpg',
        link: 'labelite'
      }
    ];
      
    // function: Toggle submenu
    let toggleSubmenu = () => {
      subMenuToggle = !subMenuToggle;
    }

    function handleClickOutside(event) {
      subMenuToggle = !subMenuToggle;
    }
    
  </script>
  
  <style>
    header {
      background: linear-gradient(177.21deg, #005397 0.77%, #00467f 76.64%);
    }
  
    .menu {
        font-family: Camphor W01 Bold;
    }
    
    .tab {
      @apply mx-6 border-b-4 border-transparent py-6 opacity-50 transition duration-300 ease-in;
    }
  
    .tab:last-child {
      @apply mr-2;
    }

    .submenu {
      @apply border-gray-300 p-6;
      border-bottom: 1px solid #ccc;
      box-shadow: 0 4px 11px rgba(0,0,0,.25);
    }

    a, a:focus, button, button:focus {
      outline:none;
    }

    .svg-icon {
      display: inline-flex;
      align-self: center;
      transition: all .3s ease-in;
    }

    .svg-icon.active {
      transform: rotate(180deg);
      opacity: 1;
    }

    .svg-icon svg {
      height:1.2em;
      width:1.2em;
      color: white;
    }

    .svg-icon.svg-baseline svg {
      top: .125em;
      position: relative;
      filter: drop-shadow(0px 8px 12px rgba(1, 122, 196, 0.1));
    }

    .item img {
      border-radius: 3px;
      transition: all .3s ease-out;
      opacity: .7;
    }

    .item:hover img {
      opacity: 1;
      filter: drop-shadow(0px 8px 12px rgba(1, 122, 196, 0.1));
    }

    .item {
      cursor: pointer;
    }

    .item.active img {
      border: 3px solid #1F74B8;
      opacity: 1;
      cursor: default;
      filter: drop-shadow(0px 8px 12px rgba(1, 122, 196, 0.1));
    }
  </style>
  
  <div style="z-index: 1;" use:clickOutside on:click_outside={subMenuToggle ? handleClickOutside : ''}>
    <header class="flex items-center px-4 py-4 lg:py-0">
      <div class="w-1/2 lg:w-1/3">
        <div class="flex items-center">
          <a href="/" title="Back to homepage">
            <Logo />
          </a>
          {#if pageTitle !== "Home"}
            <span
              class="hidden pl-6 ml-6 text-white border-l border-white border-opacity-25 lg:inline-block lg:text-base xl:text-2xl">
              {pageTitle}
            </span>
          {/if}
        </div>
  
      </div>
      <div class="w-1/2 text-right text-white lg:w-2/3">
        <span class="flex justify-end lg:hidden">
          <button on:click|preventDefault={toggleSubmenu} class="flex justify-end" class:active={subMenuToggle}>
            <span class="svg-icon" class:active={subMenuToggle}><svg aria-hidden="true" focusable="false" data-prefix="fal" data-icon="angle-down" class="svg-inline--fa fa-angle-down fa-w-8" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 256 512"><path fill="currentColor" d="M119.5 326.9L3.5 209.1c-4.7-4.7-4.7-12.3 0-17l7.1-7.1c4.7-4.7 12.3-4.7 17 0L128 287.3l100.4-102.2c4.7-4.7 12.3-4.7 17 0l7.1 7.1c4.7 4.7 4.7 12.3 0 17L136.5 327c-4.7 4.6-12.3 4.6-17-.1z"></path></svg></span>
            All Products
          </button>
        </span>
  
        <span class="items-stretch justify-end hidden my-6 text-sm menu lg:visible lg:flex">
          <a href="https://www.hamiltoncompany.com/webinar">Join a Webinar</a>
          <a href="https://www.hamiltoncompany.com/automated-sample-management/support" class="mx-8">Contact Us</a>
          <button class="flex" on:click|preventDefault={toggleSubmenu}>
            <span class="svg-icon" class:active={subMenuToggle}><svg aria-hidden="true" focusable="false" data-prefix="fal" data-icon="angle-down" class="svg-inline--fa fa-angle-down fa-w-8" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 256 512"><path fill="currentColor" d="M119.5 326.9L3.5 209.1c-4.7-4.7-4.7-12.3 0-17l7.1-7.1c4.7-4.7 12.3-4.7 17 0L128 287.3l100.4-102.2c4.7-4.7 12.3-4.7 17 0l7.1 7.1c4.7 4.7 4.7 12.3 0 17L136.5 327c-4.7 4.6-12.3 4.6-17-.1z"></path></svg></span> All Products
          </button>
        </span>
      </div>
    </header>

    {#if subMenuToggle}
      <div class:active={subMenuToggle} transition:fade class="absolute z-10 w-full bg-white submenu bottom">
        <div class="grid w-full grid-cols-2 gap-4 lg:flex lg:flex-columns lg:justify-center lg:w-3/4 lg:mx-auto lg:pt-2">
          {#each testProducts as {title, image, link}, i}
            <a href="{ENV_URL + link}" class="px-4 text-center item" class:active={PAGE_QUERY_STRING === link} data-aos="fade" data-aos-delay="{i*100}">
              <img src="{image}" alt="">
              <strong class="inline-block mt-2 text-gray-600">{title}</strong>
            </a>
          {/each}
        </div>
      </div>
    {/if}
    
  </div>
  